var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gui-item"},[_c('div',{staticClass:"gui-label"}),_vm._v(" "),_c('div',{staticClass:"gui-controller gui-button"},[_c('div',{on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-843fc42e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gui/guiButton.vue
// module id = null
// module chunks = 